import api from "api";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import _ from "lodash";
import "./../style.scss";
import { popinfo } from "component/Fancybox/Fancybox";
import { Link } from "react-router-dom";
import { MaterialSymbol } from "react-material-symbols";
import update from "immutability-helper";
import PaginationWrapper from "component/Pagination";

export default connect(stateMap)((props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [parameter, setParameter] = useState(_.assignIn({}, props.args, {
        posts_per_page: 10,
        paged: 1
    }));
    const [roles, setRoles] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [searchInput, setSearchInput] = useState(parameter.include_initiative__title_search || '');
    
    useEffect(() => {
        // setParameter(update(parameter, { $merge: props.args }));
        const newParameter = {
            ...parameter
            ,...props.args
            ,include_initiative__initiator_email : props.args?.initiator_email
        };
        setParameter(newParameter);
        
        // Sync searchInput with parameter
        if (newParameter.include_initiative__title_search) {
            setSearchInput(newParameter.include_initiative__title_search);
        } else {
            setSearchInput('');
        }
    }, [props.args])

    // Debounce search input to avoid excessive API calls
    useEffect(() => {
        const handler = setTimeout(() => {
            const trimmed = searchInput.trim();
            setParameter(prev => {
                const next = { ...prev, paged: 1 };
                if (trimmed.length >= 3) {
                    next.include_initiative__title_search = trimmed;
                } else {
                    delete next.include_initiative__title_search;
                }
                return next;
            });
        }, 500);

        return () => clearTimeout(handler);
    }, [searchInput]);

    useEffect(() => {
        setIsLoading(true);

        Promise.all([
            api('/Role', 'get', {...parameter, is_monitoring: 1, include_initiative: 1, sortby : 'InitiativeRole.RoleID DESC'}, 'Bearer ' + props.auth.token),
            api('/Role', 'get', {...parameter, is_monitoring: 1, include_initiative: 1, get_total: 1}, 'Bearer ' + props.auth.token)
        ]).then(([ResponseResult, ResponseTotal]) => {
            setIsLoading(false);
            setRoles(ResponseResult.roles);
            setTotalItems(parseInt(ResponseTotal.roles));
        })
        .catch(() => {
            setIsLoading(false);
            setRoles([]);
            setTotalItems(0);
        })
    }, [parameter]);

    const SATPointEditor = ({ initialValue, onSave }) => {
        const [value, setValue] = useState(initialValue);

        const handleSave = () => {
            onSave(value);
        };

        return (
            <div className="sat-point-editor">
                <input
                    type="number"
                    min="0"
                    max="100"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    className="form-control text sat-point-input"
                />
                <button 
                    className="btn btn-mini btn-orange btn-icon" 
                    onClick={handleSave}
                >
                    <MaterialSymbol icon="save"/>
                </button>
            </div>
        );
    };

    return (
        <div className="component-list-initiative-status component-list-monitoring">
            <div className="monitor-search-wrapper">
                <div className="monitor-search-label">
                    <MaterialSymbol icon="search" className="monitor-search-icon" />
                    <span>Search Initiative:</span>
                </div>
                <div className="monitor-search-input-wrapper">
                    <input
                        type="text"
                        className="form-control text"
                        placeholder="Enter initiative name (min. 3 characters)..."
                        value={searchInput}
                        onChange={(e) => {
                            setSearchInput(e.target.value);
                        }}
                    />
                </div>
            </div>
            <div className="monitor-filter-wrapper">
                <div className="monitor-filter-label">
                    Filter by Type:&nbsp;
                </div>
                <button className={`btn btn-mini btn-primary ${parameter.include_initiative__intiative_type === 'research' ? 'btn-reverse' : ''}`} onClick={e => {
                    setParameter({
                        ...parameter,
                        include_initiative__intiative_type: parameter.include_initiative__intiative_type === 'research' ? '' : 'research',
                        paged: 1
                    })
                }}><MaterialSymbol icon="experiment"/> Research</button>
                <button className={`btn btn-mini btn-primary ${parameter.include_initiative__intiative_type === 'event' ? 'btn-reverse' : ''}`} onClick={e => {
                    setParameter({
                        ...parameter,
                        include_initiative__intiative_type: parameter.include_initiative__intiative_type === 'event' ? '' : 'event',
                        paged: 1
                    })
                }}><MaterialSymbol icon="calendar_month"/> Event</button>
                <button className={`btn btn-mini btn-primary ${parameter.include_initiative__intiative_type === 'talent' ? 'btn-reverse' : ''}`} onClick={e => {
                    setParameter({
                        ...parameter,
                        include_initiative__intiative_type: parameter.include_initiative__intiative_type === 'talent' ? '' : 'talent',
                        paged: 1
                    })
                }}><MaterialSymbol icon="person_play"/> Talent Team</button>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>Role Name</th>
                        <th>Initiative</th>
                        <th className="sat-point-header">SAT Point</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading && 
                        <tr>
                            <td colSpan={3}>
                                <span className="skeleton"></span>
                            </td>
                        </tr>
                    }
                    {!isLoading && roles.map((role) => (
                        <tr key={role.RoleID} className="generic-form">
                            <td>{role.RoleName}</td>
                            <td>
                                <Link to={`/initiative/${role.Slug}`}>
                                    {role.Title}
                                </Link>
                            </td>
                            <td>
                                <SATPointEditor 
                                    initialValue={role.SATPoint} 
                                    onSave={(value) => {
                                        if (value !== undefined) {
                                            const SavingSAT = popinfo('preloader', 'Please Wait', "Saving role SAT Point");
                                            api('/RoleSetSAT', 'post', {
                                                role_id: role.RoleID,
                                                sat_point: value
                                            }, 'Bearer ' + props.auth.token)
                                                .then(response => {
                                                    SavingSAT.close();
                                                })
                                                .catch(err => {
                                                    popinfo('error', 'Sorry', err, {}, SavingSAT);
                                                })
                                        }
                                    }}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {!isLoading && totalItems > parameter.posts_per_page && (
                <PaginationWrapper
                    className="mt-4"
                    activePage={parameter.paged}
                    itemsCountPerPage={parameter.posts_per_page}
                    totalItemsCount={totalItems}
                    pageRangeDisplayed={5}
                    onChange={(pagenumber) => {
                        setParameter(update(parameter, { paged: {$set: pagenumber} }))
                    }}
                />
            )}
        </div>
    )
});